import * as _4 from 'lodash4';
import { ICommand } from 'core-ts-types';
import { ITimeOccurrenceDatatype } from 'ui-ng-calendar';
import { TimeOccurrenceServant } from 'ui-ng-calendar';
import { IValidator } from 'ui-ng-calendar';
import { PhxCalendarConfiguration } from 'ui-ng-calendar';
import { IDayOfTheWeekValue } from 'utility-js-time';
import { IChangedBusyTimeDatasource } from 'ui-ng-calendar';
import { UnlockedTimeQuery } from 'ui-ng-calendar';
import { TimeOccurrenceEngine } from 'ui-ng-calendar';
import { TimeOccurrenceDataSource } from 'ui-ng-calendar';
import { IChangedBusyTime } from 'ui-ng-calendar';
import { BusyTimeErrorMessage } from 'ui-ng-calendar';
import { IErrors } from '../add_busy_time/add_busy_time';

class BusyTimesController {
  public query: UnlockedTimeQuery;

  public commands: {
    deleteTimeCommand: ICommand;
    updateTimeCommand: ICommand;
    startTimeDatasourceTransactionCommand: ICommand;
    endTimeDatasourceTransactionCommand: ICommand;
  };

  public timeRange: {
    hourBegin: number;
    hourEnd: number;
  };

  private errors: IErrors;
  private isValidTime: boolean;
  public outerCb: Function;
  public currentlyEditing: boolean = false;

  constructor(
    public DayOfTheWeekEnum: IDayOfTheWeekValue,
    public ngUnlockedTimeQuery: UnlockedTimeQuery,
    public ngTimeOccurrenceServant: TimeOccurrenceServant,
    private deleteTimeCommand: ICommand,
    private updateTimeCommand: ICommand,
    public ngChangedBusyTimeDatasource: IChangedBusyTimeDatasource,
    private startTimeDatasourceTransactionCommand: ICommand,
    private endTimeDatasourceTransactionCommand: ICommand,
    private saveChangedBusyTimeCommand: ICommand,
    private resetChangedBusyTimeCommand: ICommand,
    private deleteChangedBusyTimeCommand: ICommand,
    public ngPhxCalendarConfiguration: PhxCalendarConfiguration,
    public timeLockValidatorFactory: Function,
    private ngTimeOccurrenceDataSource: TimeOccurrenceDataSource,
    private ngTimeOccurrenceEngine: TimeOccurrenceEngine,
    public timeOverlapValidatorFactory: Function
  ) {
    this.query = ngUnlockedTimeQuery;

    this.commands = {
      startTimeDatasourceTransactionCommand,
      endTimeDatasourceTransactionCommand,
      deleteTimeCommand,
      updateTimeCommand
    };

    const defaultRangeLimits = {
      hourBegin: 6,
      hourEnd: 23
    };

    this.timeRange = {
      hourBegin: parseInt(ngPhxCalendarConfiguration.hourBegin, 10) || defaultRangeLimits.hourBegin,
      hourEnd: parseInt(ngPhxCalendarConfiguration.hourEnd, 10) || defaultRangeLimits.hourEnd
    };

    this.errors = {
      found: []
    };
  }

  $onDestroy() {
    this.exitEditing();
  }

  execCb() {
    return this.outerCb();
  }

  editTime(timeChangeParams: ITimeOccurrenceDatatype) {
    let dataToWrite = {
      tracking_id: timeChangeParams.trackingId,
      day_of_week: timeChangeParams.day,
      from_tm: timeChangeParams.from,
      to_tm: timeChangeParams.to,
      is_new_time: false,
      originalTimeObj: timeChangeParams
    };
    this.currentlyEditing = true;
    this.saveChangedBusyTimeCommand(dataToWrite);
  }

  showEditButton(time: any) {
    return (
      !_4.get(time, '_isCurrentlyEditing', false) &&
      !this.currentlyEditing &&
      _4.isEmpty(this.ngTimeOccurrenceServant.getNewTime(this.ngChangedBusyTimeDatasource))
    );
  }

  onTimeChanged(timeChangeParams: {
    timeParams: { timeProperty: string; originalTime: ITimeOccurrenceDatatype; updatedTimeString: string };
  }) {
    const militaryTime = moment(timeChangeParams.timeParams.updatedTimeString, 'hh:mm a').format('HH:mm');

    let propToUpdate = {};
    if (timeChangeParams.timeParams.timeProperty === 'from_tm') {
      propToUpdate = { from_tm: militaryTime };
    } else {
      propToUpdate = { to_tm: militaryTime };
    }
    this.updateTime(
      _4.merge(propToUpdate, {
        tracking_id: timeChangeParams.timeParams.originalTime.trackingId
      })
    );
  }

  updateTime(timeObj: any) {
    this.saveChangedBusyTimeCommand(timeObj);
  }

  onDayChangedEvent(event: any) {
    if (!event.target.value) {
      return;
    }

    const originalTimeObj = _4.find(this.query.result.times, { trackingId: event.target.getAttribute('tracking-id') });
    let timeObj = _4.clone(originalTimeObj);
    timeObj.day = this.DayOfTheWeekEnum.get(event.target.value.substring(2, 0));

    if (originalTimeObj.day.key !== timeObj.day.key) {
      this.onDayChanged(timeObj, originalTimeObj);
    }
  }

  onDayChanged(timeObj: ITimeOccurrenceDatatype, originalTimeObj: { day: { key: string } }) {
    const originalDayTimeObj = _4.clone(timeObj);
    originalDayTimeObj.day = this.DayOfTheWeekEnum.get(originalTimeObj.day.key);
    this.updateTime({
      tracking_id: timeObj.trackingId,
      day_of_week: timeObj.day.ordinal,
      originalTimeObj: originalTimeObj
    });
  }

  async onDeleteRecordPress(timeOccurrence: ITimeOccurrenceDatatype) {
    const boundTimeLockValidator: IValidator = this.timeLockValidatorFactory(timeOccurrence);
    await this.commands.startTimeDatasourceTransactionCommand(boundTimeLockValidator);
    await this.commands.deleteTimeCommand(timeOccurrence).then(() => {
      this.commands.endTimeDatasourceTransactionCommand();
      this.execCb();
      this.exitEditing();
    });
  }

  onValueChange(event: any) {
    const previousTime = _4.find(this.query.result.times, { trackingId: event.target.getAttribute('tracking-id') });

    if (
      _4.includes(event.target.getAttribute('time-property'), 'from') &&
      event.detail.value === previousTime.from.format('h:mm A')
    ) {
      return;
    } else if (event.detail.value === previousTime.to.format('h:mm A')) {
      return;
    }

    this.onTimeChanged({
      timeParams: {
        originalTime: previousTime,
        timeProperty: event.target.getAttribute('time-property'),
        updatedTimeString: event.detail.value
      }
    });
  }

  hasChangedTimeConflicts(time: any) {
    let hasConflicts = false;
    time.to = _4.isString(time.to_tm) ? moment(time.to_tm + ':00', 'HH:mm:ss') : time.to_tm;
    time.from = _4.isString(time.from_tm) ? moment(time.from_tm + ':00', 'HH:mm:ss') : time.from_tm;
    time.day = _4.isObject(time.day_of_week) ? time.day_of_week : this.DayOfTheWeekEnum.get(time.day_of_week);
    const overlappingTimes = this.ngTimeOccurrenceEngine.findOverlappingTimes(
      time,
      this.ngTimeOccurrenceDataSource.store
    );

    if (
      !_4.isEmpty(_4.filter(overlappingTimes, (item: ITimeOccurrenceDatatype) => item.trackingId !== time.tracking_id))
    ) {
      hasConflicts = true;
    }
    return hasConflicts;
  }

  async saveUpdatedTimes() {
    const updatedTimes = this.ngTimeOccurrenceServant.getUpdatedTimes(this.ngChangedBusyTimeDatasource);

    this.validatePotentialTime(updatedTimes);

    if (!this.isValidTime) {
      return;
    }
    if (this.hasChangedTimeConflicts(updatedTimes)) {
      this.errors.found.push(BusyTimeErrorMessage['isTimeOverlap'].message);
      return;
    }

    const boundTimeLockValidator: IValidator = this.timeLockValidatorFactory(updatedTimes.originalTimeObj);

    await this.startTimeDatasourceTransactionCommand(boundTimeLockValidator).then(() => {
      //Hack id of changed time needs to be from server
      updatedTimes.id = updatedTimes.originalTimeObj.id;
      this.updateTimeCommand(updatedTimes.originalTimeObj, updatedTimes).then(
        (currentTimeOccurrence: ITimeOccurrenceDatatype) => {
          this.endTimeDatasourceTransactionCommand();
          this.deleteChangedBusyTimeCommand(updatedTimes.tracking_id);
          this.exitEditing();
        }
      );
    });
  }

  exitEditing() {
    if (this.currentlyEditing) {
      this.resetChangedBusyTimeCommand();
    }
    this.currentlyEditing = false;
    this.errors.found = [];
  }

  validatePotentialTime(updatedTimes: IChangedBusyTime) {
    this.errors.found = this.ngTimeOccurrenceServant.validatePotentialTime(updatedTimes, this.errors, this.timeRange);
    this.isValidTime = _4.isEmpty(this.errors.found);
  }
}

angular
  .module('capability-ng-scheduler')
  .controller('BusyTimesController', BusyTimesController)
  .component('busyTimes', {
    templateUrl: 'capability-ng-scheduler/src/components/busy_times/busy_times.html',
    bindings: {
      enums: '<',
      includeWeekends: '@',
      microheaders: '@',
      hourStep: '@',
      hourBegin: '@',
      hour: '@',
      outerCb: '&x',
      times: '<'
    },
    controller: 'BusyTimesController'
  });



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-scheduler/src/components/busy_times/busy_times.ts